import { h } from 'preact';
import { useEffect, useRef } from 'preact/hooks';
import { VOID_FN } from '../../../../../utils';
import { useStyles } from '../../../../common/hooks';
import { DIALOG_LAYER_OPEN } from '../../../theme/constants';
import { SETTINGS_WRAPPER_STYLE } from '../../controls/extra/styles';
import { MODAL_CONTAINER_STYLES } from './styles';
import { MODAL_BACK_BUTTON_NAME } from './types';

export function Modal({
  trap = false,
  show,
  styles,
  stylesDirectOverride = {},
  onChange = VOID_FN,
  onEscapeKeyDown = VOID_FN,
  closeComponent,
  closingButtonStyle,
  attachedTo,
  children,
  ...props
}) {
  const setStyles = useStyles();

  const modalBodyRef = useRef(null);

  useEffect(() => {
    const outOfBounds = (e = {}) => {
      if (!show || !modalBodyRef.current) return;

      const activeElement = e.relatedTarget || document.activeElement;

      const activeElementIsOutsideTheModal = activeElement.getAttribute('name') !== attachedTo && activeElement.getAttribute('name') !== MODAL_BACK_BUTTON_NAME && !modalBodyRef.current.contains(activeElement) && modalBodyRef.current !== activeElement;

      if (!activeElementIsOutsideTheModal) {
        return;
      }

      if (trap && closeComponent && closeComponent.props?.name) {
        const close = modalBodyRef.current.querySelector(`[name=${closeComponent.props.name}]`);
        if (close) close.focus();
        return;
      }

      if (onChange) {
        onChange(false);
      }
    };

    outOfBounds();

    if (window.addEventListener) window.addEventListener('focusout', outOfBounds, true);
    else window.attachEvent('onfocusout', outOfBounds);

    return () => {
      if (window.removeEventListener) window.removeEventListener('focusout', outOfBounds, true);
      else window.detachEvent('onfocusout', outOfBounds);
    };
  }, [show]);

  const handleEscapeKeyDown = (e) => {
    if (e.keyCode === 27 /* ESC */) {
      e.preventDefault();
      e.stopPropagation();
      onEscapeKeyDown(e);
    }
  };

  return show && (

    // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
    <div
      aria-modal="true"
      ref={modalBodyRef}
      onKeyDown={(e) => {
        handleEscapeKeyDown(e);
      }}
      style={{
        opacity: show ? 1 : 0,
        ...SETTINGS_WRAPPER_STYLE,
        ...setStyles(MODAL_CONTAINER_STYLES),
        ...setStyles(styles),
        ...stylesDirectOverride,
        overflow: 'hidden',
        zIndex: DIALOG_LAYER_OPEN
      }}
      role="dialog"
      {...props}
    >
      {/* Using a role here cause VoiceOver issues */}
      {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions */}
      <div
        style={{ height: '100%' }}
        onClick={(e) => e.stopPropagation()}
        onKeyPress={(e) => {
          e.stopPropagation();
          e.preventDefault();
        }}
      >
        <div style={closingButtonStyle}>{closeComponent}</div>
        {children}
      </div>
    </div>
  );
}
